import { visitorHeaderText } from "./visitor-header-copy";

export interface VisitorNavItem {
  label: string;
  /** Route, or the home page followed by a section anchor. */
  href: string;
  /** Id of the home section the link scrolls to, when it is one. */
  section?: string;
}

/** The visitor's links: three sections of the home page and the leaderboard. */
export function visitorNav(lang: string, language: string): VisitorNavItem[] {
  const copy = visitorHeaderText(language);
  const home = `/${lang}`;
  return [
    { label: copy.howItWorks, href: `${home}#home-how-title`, section: "home-how-title" },
    { label: copy.languages, href: `${home}#home-languages-title`, section: "home-languages-title" },
    { label: copy.leaderboard, href: `${home}/leaderboard` },
    { label: copy.faq, href: `${home}#home-faq-title`, section: "home-faq-title" },
  ];
}

/** True on the public home page, where section links scroll in place. */
export function isHomePath(pathname: string, lang: string): boolean {
  const path = pathname.replace(/\/+$/, "");
  return path === `/${lang}` || path === `/${lang}/site`;
}

/** Smoothly brings the home section holding this heading under the sticky header. */
export function scrollToSection(id: string, behavior: ScrollBehavior = "smooth"): boolean {
  const heading = document.getElementById(id);
  if (!heading) return false;
  (heading.closest("section") ?? heading).scrollIntoView({ behavior, block: "start" });
  return true;
}
